/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Say_HelloInputs */

const en_contact_say_hello = /** @type {(inputs: Contact_Say_HelloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Say hello`)
};

const ar_contact_say_hello = /** @type {(inputs: Contact_Say_HelloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أرسل تحية`)
};

const bn_contact_say_hello = /** @type {(inputs: Contact_Say_HelloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`হ্যালো বলুন`)
};

const de_contact_say_hello = /** @type {(inputs: Contact_Say_HelloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sag Hallo`)
};

const es_contact_say_hello = /** @type {(inputs: Contact_Say_HelloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saluda`)
};

const fr_contact_say_hello = /** @type {(inputs: Contact_Say_HelloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dites bonjour`)
};

const pt_contact_say_hello = /** @type {(inputs: Contact_Say_HelloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diga olá`)
};

const zh_contact_say_hello = /** @type {(inputs: Contact_Say_HelloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打个招呼`)
};

const tr_contact_say_hello = /** @type {(inputs: Contact_Say_HelloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merhaba deyin`)
};

const ru_contact_say_hello = /** @type {(inputs: Contact_Say_HelloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Передавай привет`)
};

const pl_contact_say_hello = /** @type {(inputs: Contact_Say_HelloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przywitaj się`)
};

/**
* | output |
* | --- |
* | "Say hello" |
*
* @param {Contact_Say_HelloInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_say_hello = /** @type {((inputs?: Contact_Say_HelloInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Say_HelloInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_contact_say_hello(inputs)
	if (locale === "bn") return bn_contact_say_hello(inputs)
	if (locale === "de") return de_contact_say_hello(inputs)
	if (locale === "es") return es_contact_say_hello(inputs)
	if (locale === "fr") return fr_contact_say_hello(inputs)
	if (locale === "pt") return pt_contact_say_hello(inputs)
	if (locale === "zh") return zh_contact_say_hello(inputs)
	if (locale === "tr") return tr_contact_say_hello(inputs)
	if (locale === "ru") return ru_contact_say_hello(inputs)
	if (locale === "pl") return pl_contact_say_hello(inputs)
	return en_contact_say_hello(inputs)
});